/**
 * @fileoverview dragscroll - scroll area by dragging
 * @version 0.0.8
 *
 * This is a patched version: https://github.com/iluhaua/dragscroll/tree/patch-1
 * 
 * @license MIT, see http://github.com/asvd/dragscroll
 * @copyright 2015 asvd <heliosframework@gmail.com> 
 */

!function(e,n){"function"==typeof define&&define.amd?define(["exports"],n):"undefined"!=typeof exports?n(exports):n(e.dragscroll={})}(this,function(e){var r,s,d=window,m=document,a="mousemove",u="mouseup",f="mousedown",n="EventListener",g="add"+n,t="remove"+n,o=[],l=function(e,n){for(e=0;e<o.length;)(n=(n=o[e++]).container||n)[t](f,n.md,0),d[t](u,n.mu,0),d[t](a,n.mm,0);for(o=[].slice.call(m.getElementsByClassName("dragscroll")),e=0;e<o.length;)!function(n,t,o,l,i,c){(c=n.container||n)[g](f,c.md=function(e){n.hasAttribute("nochilddrag")&&m.elementFromPoint(e.pageX,e.pageY)!=c||(l=1,t=e.clientX,o=e.clientY,e.preventDefault())},0),d[g](u,c.mu=function(){l=0,setTimeout(function(){n.classList.remove("dragging")},100)},0),d[g](a,c.mm=function(e){l&&(n.classList.add("dragging"),(i=n.scroller||n).scrollLeft-=r=-t+(t=e.clientX),i.scrollTop-=s=-o+(o=e.clientY),n==m.body&&((i=m.documentElement).scrollLeft-=r,i.scrollTop-=s))},0)}(o[e++])};"complete"==m.readyState?l():d[g]("load",l,0),e.reset=l});




//////////////////
// WEBPACK FOOTER
// ../atum-stock-manager-for-woocommerce/assets/js/vendor/dragscroll.min.js
// module id = 40
// module chunks = 0